<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="供应商名称" fieldDecoratorId="name">
              <a-input placeholder="请输入供应商名称" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-button style="margin-left: 10px;" type="primary" @click="handleAdd" icon="plus">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
    >
      <template slot="goodsCategoryContent" slot-scope="text">
        <template v-for="item in text">
          {{ item.name }},
        </template>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <a-popconfirm title="确定删除此供应商吗？" @confirm="handleDelete(record)" okText="是" cancelText="否">
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
        </div>
      </template>
    </s-table>

    <a-modal
      title="供应商管理"
      :width="600"
      v-model="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          v-if="mdl.id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='供应商编号'
          fieldDecoratorId="id"
          :fieldDecoratorOptions="{
            initialValue: mdl.id,
          }"
        >
          <a-input placeholder='供应商编号'/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='供应商名称'
          fieldDecoratorId="name"
          :fieldDecoratorOptions="{
            rules: [{ required: true }],
            initialValue: mdl.name,
          }"
        >
          <a-input placeholder='供应商名称' />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='供应商地址'
          fieldDecoratorId="address"
          :fieldDecoratorOptions="{
            rules: [{ required: true }],
            initialValue: mdl.address,
          }"
        >
          <a-input placeholder='供应商地址' />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='联系人姓名'
          fieldDecoratorId="contact_name"
          :fieldDecoratorOptions="{
            rules: [{ required: true }],
            initialValue: mdl.contact_name,
          }"
        >
          <a-input placeholder='联系人姓名' />
        </a-form-item>   
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='联系人电话'
          fieldDecoratorId="phone_number"
          :fieldDecoratorOptions="{
            rules: [{ required: true }],
            initialValue: mdl.phone_number,
          }"
        >
          <a-input placeholder='联系人电话' />
        </a-form-item>  
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="分类"
          fieldDecoratorId="goods_categorys_id"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请选择类别'}],
            initialValue: mdl.goods_categorys_id
          }"
        >
          <a-select placeholder="请选择类别" mode="multiple" allowClear show-search option-filter-prop="children">
            <a-select-option v-for="d in categories" :key="d.id">{{ d.name }}</a-select-option>
          </a-select>
        </a-form-item>  
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import { getCategoryList } from '@/api/category'
import { getSupplierList,updateSupplier,deleteSupplier } from '@/api/supplier'

export default {
  name: 'Supplier',
  components: {
    STable,
    AInput
  },
  data() {
    return {
      visible: false,
      managerVisible:false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null, 
      managerform: null,
      mdl: {},
      supplier:[],
      managerList:[],
      categories:[],
      queryParam: {},// 查询参数
      selectedSupplier:{},
      contact:{},
      columns: [
        {
          title: '供应商编号',
          dataIndex: 'id'
        },
        {
          title: '供应商名称',
          dataIndex: 'name',
        },
        {
          title: '供应商地址',
          dataIndex: 'address',
        },
        {
          title: '供应商分类',
          dataIndex: 'goods_categorys',
          scopedSlots: { customRender: 'goodsCategoryContent' },
        },
         {
          title: '联系人',
          dataIndex: 'contact_name',
        },
        {
          title: '联系方式',
          dataIndex: 'phone_number',
        },   
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
            // 加载数据方法 必须为 Promise 对象
    loadData: (params) => {
        return getSupplierList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    }
  },
  created(){
    // this.getSupplierList();
    this.getCategoryList();
  },
  methods: {
       //列表查询
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        name: this.searchForm.getFieldValue("name"),
      };
      this.$refs.table.refresh();
    },
    // getSupplierList() {
    //   getSupplierList().then(res => {
    //     this.supplier = res.list
    //   })
    // },
    getCategoryList: function () {
      getCategoryList({page_size:10000}).then(res => {
        this.categories = res.list
      })
    },
    handleAdd() {
      this.mdl = {}
      this.visible = true
    },
    handleDelete(row) {
      deleteSupplier(row.id).then(res => {
        this.$message.success('操作成功')
        // this.getSupplierList()
        this.$refs.table.refresh();
      })
    },
    handleEdit(record) {
      console.log(record)
      this.mdl = Object.assign({}, {...record,goods_categorys_id:record.goods_categorys.map(i => i.id)})
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          updateSupplier(values).then(res => {
            // this.getSupplierList()
            this.$message.success('操作成功')
            this.form.resetFields()
            this.visible = false
            this.$refs.table.refresh();
          })
                 
        }
      })
    },
    handleCancel () {
      this.form.resetFields()
      this.visible = false
    },
  }
}
</script>
<style scoped>
.add-btn {
  margin-bottom: 10px;
}
</style>